// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting {
  padding: 1rem;
  margin-top: 6rem;
}

.setting .left {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 0 !important;
}

.setting .left .ImageDiv .profile {
  /* width: 100px; */
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  border-radius: 20px;
}

.setting .left h3 {
  text-align: center;
  margin-top: 6px;
  font-weight: 600;
  margin-bottom: 0;
}

.setting .left h4 {
  text-align: center;
  margin-top: 0;
}

.setting .left .profileMenu {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  margin-bottom: 3rem;
  width: 100%;
}

.setting .left .profileMenu .menu {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0.5rem 0;
  cursor: pointer;
}

.setting .left .profileMenu .menu div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70%;
}

.setting .left .profileMenu .menu p {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: gray;
  width: 80%;
}

.setting .left .profileMenu .menu .icon {
  width: 20%;
  font-size: 18px;
}

.setting .left .profileMenu .unactive {
  border-right: 5px solid transparent;
}

.setting .left .profileMenu .active {
  background-color: var(--background);
}

.setting .left .profileMenu .general.active .icon {
  color: #8a1b6a !important;
}

.setting .left .profileMenu .general.active .vendorInfo {
  color: #5dbfa8 !important;
}

.setting .left .profileMenu .vendorInfo {
  border-right: 5px solid #5dbfa8;
}

.setting .left .profileMenu .general {
  border-right: 5px solid #8a1b6a;
}

.setting .left .profileMenu .verification {
  border-right: 5px solid #2ecc71;
}

.setting .left .profileMenu .dashboard {
  border-right: 5px solid #f4d03f;
}

.setting .left .profileMenu .active p {
  color: var(--text);
}

.setting .right {
  padding: 1rem 2rem !important;
  padding-bottom: 0;
}

.setting .right .form-btn {
  justify-content: flex-end;
  padding: 10px;
  padding-bottom: 1rem;
}

.ant-input-password-icon.anticon {
  color: var(--text) !important;
}

.setting .facebook {
  color: #3b5998;
  cursor: pointer;
}
.setting .instagram {
  color: #c13584;
  cursor: pointer;
}
.setting .linkedin {
  color: #0072b1;
  cursor: pointer;
}

.setting .form-btn {
  display: flex;
  justify-content: flex-end;
}
.setting .form-btn button {
  width: 150px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/settings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd","sourcesContent":[".setting {\n  padding: 1rem;\n  margin-top: 6rem;\n}\n\n.setting .left {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  padding: 0 !important;\n}\n\n.setting .left .ImageDiv .profile {\n  /* width: 100px; */\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2rem;\n  border-radius: 20px;\n}\n\n.setting .left h3 {\n  text-align: center;\n  margin-top: 6px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.setting .left h4 {\n  text-align: center;\n  margin-top: 0;\n}\n\n.setting .left .profileMenu {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1rem;\n  margin-bottom: 3rem;\n  width: 100%;\n}\n\n.setting .left .profileMenu .menu {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 0.5rem 0;\n  cursor: pointer;\n}\n\n.setting .left .profileMenu .menu div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 70%;\n}\n\n.setting .left .profileMenu .menu p {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  color: gray;\n  width: 80%;\n}\n\n.setting .left .profileMenu .menu .icon {\n  width: 20%;\n  font-size: 18px;\n}\n\n.setting .left .profileMenu .unactive {\n  border-right: 5px solid transparent;\n}\n\n.setting .left .profileMenu .active {\n  background-color: var(--background);\n}\n\n.setting .left .profileMenu .general.active .icon {\n  color: #8a1b6a !important;\n}\n\n.setting .left .profileMenu .general.active .vendorInfo {\n  color: #5dbfa8 !important;\n}\n\n.setting .left .profileMenu .vendorInfo {\n  border-right: 5px solid #5dbfa8;\n}\n\n.setting .left .profileMenu .general {\n  border-right: 5px solid #8a1b6a;\n}\n\n.setting .left .profileMenu .verification {\n  border-right: 5px solid #2ecc71;\n}\n\n.setting .left .profileMenu .dashboard {\n  border-right: 5px solid #f4d03f;\n}\n\n.setting .left .profileMenu .active p {\n  color: var(--text);\n}\n\n.setting .right {\n  padding: 1rem 2rem !important;\n  padding-bottom: 0;\n}\n\n.setting .right .form-btn {\n  justify-content: flex-end;\n  padding: 10px;\n  padding-bottom: 1rem;\n}\n\n.ant-input-password-icon.anticon {\n  color: var(--text) !important;\n}\n\n.setting .facebook {\n  color: #3b5998;\n  cursor: pointer;\n}\n.setting .instagram {\n  color: #c13584;\n  cursor: pointer;\n}\n.setting .linkedin {\n  color: #0072b1;\n  cursor: pointer;\n}\n\n.setting .form-btn {\n  display: flex;\n  justify-content: flex-end;\n}\n.setting .form-btn button {\n  width: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
